(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amazing-testimonial"] && !Shopify.designMode) return;
  try {
    

      var swiper = new Swiper('.testimonial-swiper', {
        slidesPerView: 3,
        spaceBetween: 20,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },
         navigation: {
          nextEl: ".test-button-next",
          prevEl: ".test-button-prev",
        },
        breakpoints: {
          0: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 }
        }
      });
    

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-template--product-new"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.c-collection-products-container');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          const cCollectionProductsSwiper = new Swiper('.c-collection-products-swiper', {
            // Optional parameters
            spaceBetween: 12,
            slidesPerView: 'auto',
            // If we need pagination
            // pagination: {
            //   el: '.swiper-pagination',
            //   clickable: true,
            // },

            // Navigation arrows
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },

            // And if we need scrollbar
            scrollbar: {
              el: '.swiper-scrollbar',
            },
          });
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.c-collection-products-container');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["c-template--product"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.c-collection-products-container');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          const cCollectionProductsSwiper = new Swiper('.c-collection-products-swiper', {
            // Optional parameters
            spaceBetween: 12,
            slidesPerView: 'auto',
            // If we need pagination
            // pagination: {
            //   el: '.swiper-pagination',
            //   clickable: true,
            // },

            // Navigation arrows
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },

            // And if we need scrollbar
            scrollbar: {
              el: '.swiper-scrollbar',
            },
          });
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.c-collection-products-container');
  const observer = new IntersectionObserver(handleIntersection, { rootMargin: '0px 0px 200px 0px' });

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clients-testimonial"] && !Shopify.designMode) return;
  try {
    
    var swiper = new Swiper('.featurred-testimonial-swiper', {
      slidesPerView: 1,
      loop: true,
      speed:1000,
      navigation: {
        nextEl: '.featured-test-next',
        prevEl: '.featured-test-prev',
      },
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-arriivals"] && !Shopify.designMode) return;
  try {
    
  var swiper = new Swiper('.new-arrivals-swiper', {
    slidesPerView: 3.5,
    spaceBetween: 30,
    speed:1000,
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: true,
    },
    navigation: {
      nextEl: '.button-next',
      prevEl: '.button-prev',
    },
    breakpoints: {
      // small screens (phones)
      0: {
        slidesPerView: 1.2,
        spaceBetween: 16,
      },
      // medium screens (tablets)
      768: {
        slidesPerView: 2.2,
        spaceBetween: 20,
      },
      // large screens (desktops)
      1024: {
        slidesPerView: 3.5,
        spaceBetween: 30,
      },
    },
  });

  } catch(e) { console.error(e); }
})();
})();
